import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function UserIcon({
  color = "lightblack",
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clip-path="url(#clip0_5144_13595)">
        <path
          d="M7.99984 1.3335C6.15889 1.3335 4.6665 2.82588 4.6665 4.66683C4.6665 6.50778 6.15889 8.00016 7.99984 8.00016C9.84079 8.00016 11.3332 6.50778 11.3332 4.66683C11.3332 2.82588 9.84079 1.3335 7.99984 1.3335Z"
          fill={COLORS[color]}
        />
        <path
          d="M5.99984 9.3335C4.15889 9.3335 2.6665 10.8259 2.6665 12.6668V13.3335C2.6665 14.0699 3.26346 14.6668 3.99984 14.6668H7.90987C7.54166 13.9703 7.33317 13.1762 7.33317 12.3335C7.33317 11.2079 7.70511 10.1692 8.3328 9.3335H5.99984Z"
          fill={COLORS[color]}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9998 12.3335C15.9998 14.3585 14.3582 16.0002 12.3332 16.0002C10.3081 16.0002 8.6665 14.3585 8.6665 12.3335C8.6665 10.3085 10.3081 8.66683 12.3332 8.66683C14.3582 8.66683 15.9998 10.3085 15.9998 12.3335ZM11.9998 10.6668C12.368 10.6668 12.6665 10.9653 12.6665 11.3335V12.0002H13.3332C13.7014 12.0002 13.9998 12.2986 13.9998 12.6668C13.9998 13.035 13.7014 13.3335 13.3332 13.3335H11.9998C11.6316 13.3335 11.3332 13.035 11.3332 12.6668V11.3335C11.3332 10.9653 11.6316 10.6668 11.9998 10.6668Z"
          fill={COLORS[color]}
        />
      </g>
      <defs>
        <clipPath id="clip0_5144_13595">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
